var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWikiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7273 4.19891C37.2276 1.60062 42.7723 1.60062 47.2727 4.19891L67.3683 15.8011C71.8687 18.3994 74.641 23.2012 74.641 28.3978V51.6022C74.641 56.7988 71.8687 61.6006 67.3683 64.1989L47.2727 75.8011C42.7723 78.3994 37.2277 78.3994 32.7273 75.8011L12.6317 64.1989C8.13133 61.6006 5.35898 56.7988 5.35898 51.6022V28.3978C5.35898 23.2012 8.13133 18.3994 12.6317 15.8011L32.7273 4.19891Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9297 35.2382V56.8408H45.3153V53.413C43.1214 56.1857 40.124 57.5721 36.3232 57.5721C32.5225 57.5721 29.5715 56.3381 27.4702 53.8701C25.369 51.402 24.3184 47.898 24.3184 43.358V24.8477H35.2572V43.0381C35.2572 44.9882 35.6744 46.4507 36.5086 47.4257C37.343 48.3703 38.5018 48.8425 39.985 48.8425C41.4373 48.8425 42.627 48.3246 43.554 47.2886C44.5119 46.2221 44.9909 44.6834 44.9909 42.6724V35.2382H55.9297Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9629 24.8477H55.8933V33.0192H44.9629L44.9629 24.8477Z",
    fill: "#CCFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiLogo);
export default __webpack_public_path__ + "static/media/wikiLogo.b13121c767efc9782853eb52fd7e7628.svg";
export { ForwardRef as ReactComponent };